
























































































































import {SeasonSelect, LeaderboardList, SelectedSeason} from '@/components';
import {Skill, GeekItem, GeekItemForLeaderboard, Geek} from '@/models';
import {GeekSkill, Season} from '@/models/geek-profile';
import {PersonalBest} from '@/models/leaderboard';
import {getPercentValue} from '@/utils';
import {leaderboardMixin} from '@/shared';
import {Actions, typedStore} from '@/store';
import svg from 'svg-progress-bar';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import numeral from 'numeral';
import {GeekProfileGeneralPosition} from '@/models/dashboard';
import SkillIcon from '@/views/leaderboard/SkillIcon.vue';

export default mixins(leaderboardMixin).extend({
  name: 'LeaderboardView',
  components: {
    LeaderboardList,
    SeasonSelect,
    SelectedSeason,
    SkillIcon,
    'svg-progress': svg,
  },
  data() {
    return {
      displayJumpOverText: true,
      filters: {
        immediate: {
          skill: Skill.General,
        },
      },
      skills: Object.values(Skill),
    };
  },
  created() {
    this.loadLeaderboard();
  },
  computed: {
    skillScores(): GeekSkill[] {
      return typedStore(this).state.scores.skillScores;
    },
    personalBest(): PersonalBest {
      return typedStore(this).state.scores.personalBest;
    },
    geekBasicInfo(): GeekItem {
      return typedStore(this).state.geek.geek;
    },
    geekGeneralPosition(): GeekProfileGeneralPosition {
      return typedStore(this).state.scores.generalPosition;
    },
    geek(): GeekItem & GeekProfileGeneralPosition {
      return {...this.geekBasicInfo, ...this.geekGeneralPosition};
    },
    geekInfoText(): string {
      return this.$t(
        'dashboard.geek-info.jump-on',
        {
          gxpNumber: `<span>${this.geek.gxpToJumpOnNextPosition}</span>`,
          gxp: `<span>${this.$t('dashboard.geek-info.gxp')}</span>`,
          position: `<span>${numeral(this.geek.nextPosition).format('Oo')}</span>`,
          place: `<span>${this.$t('dashboard.geek-info.place')}</span>`,
        },
      ) as string;
    },
    isSomebodyToJumpOver(): boolean {
      return !!this.geek.nextPosition;
    },
  },
  methods: {
    loggedGeek(): Geek {
      return this.$store.state.geek.current;
    },
    isActiveSkill(skill: Skill): boolean {
      return skill === this.filters.immediate.skill;
    },
    setActiveSkill(skill: Skill) {
      this.filters.immediate.skill = skill;
    },
    getSkillProgress(skill: Skill) {
      return {
        radius: 60,
        circleLineCap: 'round',
        varyStrokeArray: [20, 4],
        pathColors: ['#dedede', '#ff6900'],
        duration: 150,
        text: () => {
          return `<img src='${this.publicPath}icons/skills/${skill}-active-md.png' class='skill-image' />`;
        },
      };
    },
    async loadLeaderboard() {
      this.loader.isLeaderboardPending = true;
      this.loader.isGeekDetailsPending = true;
      try {
        await this.$store.dispatch(Actions.seasons.fetchAllSeasons),
          await this.$store.dispatch(Actions.seasons.fetchCurrentSeason);
        await this.$store.dispatch(Actions.geek.fetchGeekBasicInfo, this.activeGeek.id);
        await this.$store.dispatch(Actions.scores.fetchGeekGeneralPosition),
          this.activeSeason = this.$route.query.seasonId
            ? this.seasons.find((s: Season) => s.id === this.$route.query.seasonId) as Season
            : this.currentSeason as Season;
        await Promise.all([
          this.$store.dispatch(Actions.scores.fetchLeaderboard,
            {...this.filters.debounce, ...this.filters.immediate, seasonId: this.activeSeason.id}),
          this.$store.dispatch(
            Actions.scores.fetchGeekGeneralScore,
            {seasonId: this.activeSeason.id, geekId: this.currentGeek.id},
          ),
          this.$store.dispatch(
            Actions.scores.fetchGeekSkillScores,
            {seasonId: this.activeSeason.id, geekId: this.currentGeek.id},
          ),
          this.$store.dispatch(
            Actions.scores.fetchGeekPersonalBest,
            {seasonId: this.activeSeason.id, geekId: this.currentGeek.id},
          ),
        ]);
        this.activeGeek = {
          ...this.currentGeek,
          ...this.generalScore,
          ...this.personalBest,
        };
      } finally {
        this.loader.isLeaderboardPending = false;
        this.loader.isGeekDetailsPending = false;
      }
    },
    async setActiveGeek(geek: GeekItemForLeaderboard) {
      this.loader.isGeekDetailsPending = true;
      if (geek.id !== this.loggedGeek().id) {
        this.displayJumpOverText = false;
      } else {
        this.displayJumpOverText = true;
      }
      try {
        await Promise.all([
          this.$store.dispatch(Actions.geek.fetchGeekBasicInfo, geek.id),
          this.$store.dispatch(
            Actions.scores.fetchGeekSkillScores,
            {seasonId: this.activeSeason.id, geekId: geek.id},
          ),
          this.$store.dispatch(
            Actions.scores.fetchGeekGeneralScore,
            {seasonId: this.activeSeason.id, geekId: geek.id},
          ),
          this.$store.dispatch(
            Actions.scores.fetchGeekPersonalBest,
            {seasonId: this.activeSeason.id, geekId: geek.id},
          ),
        ]);
        this.activeGeek = {
          ...this.currentGeek,
          ...this.generalScore,
          ...this.personalBest,
        };
      } finally {
        this.loader.isGeekDetailsPending = false;
      }
    },
    getPercentValue,
  },
});
